import {IColumn,} from "@fluentui/react";
import React, {FC, useCallback, useEffect, useMemo, useState,} from "react";
import Axios from "axios";
import axios from "axios";
import {useTranslation} from "react-i18next";
import "../../node_modules/codemirror/lib/codemirror.css";
import "../../node_modules/codemirror/theme/material.css";
import "../styles/CodeMirror.css";
import {useBoolean} from "@fluentui/react-hooks";
import {useParams} from "react-router-dom";
import {SQLEditorGlobal} from "./SQLEditorGlobal";
import {SQLDefinition} from "./CMElement";

require("codemirror/mode/sql/sql");
require("codemirror/mode/xml/xml");

interface ICompanySQL {
    // connectionName: string;
    companyIdOverride?: number;
    defaultHeight?: any;
}

export const CompanySQL: FC<ICompanySQL> = ({companyIdOverride, defaultHeight}) => {
    const [sqlQuery, setSqlQuery] = useState<string | null>();
    const [sqlQueryResponse, setSqlQueryResponse] = useState<
        any[][] | undefined
    >();
    const [sqlQueryError, setSqlQueryError] = useState<string | undefined>();
    const [sqlQueryColumns, setSqlQueryColumns] = useState<
        IColumn[] | undefined
    >();
    const [showAddPacket, setShowAddPacket] = useState(false);
    const [sqlQueryWarning, setSqlQueryWarning] = useState<string>();
    const [responseText, setResponseText] = useState("");
    const [loading, {setTrue: setLoading, setFalse: setNotLoading}] =
        useBoolean(false);
    const {t} = useTranslation();
    const {id} = useParams<{ id: string }>();

    const companyId = useMemo(() => (companyIdOverride ?? (id ? +id : undefined)), [id, companyIdOverride]);

    useEffect(() => {
        if (companyId) {
            const oldQuery = localStorage.getItem(companyId + "-sql-query");
            if (oldQuery) {
                setSqlQuery(oldQuery);
            }
        }
    }, [companyId]);

    const sqlQueryChanged = useCallback(
        (event: any, newval?: string) => {
            if (companyId) {
                localStorage.setItem(companyId + "-sql-query", newval ?? "");
                setSqlQuery(newval ?? "");
            }
        },
        [companyId],
    );

    const GetMinWidth = (m: string) => {
        const mt = m.slice(0, 2);
        switch (mt) {
            case "ac":
                return 250;
            case "an":
                return 75;
            case "ad":
                return 140;
            default:
                return 100;
        }
    };

    const executeSqlQueryContinue = useCallback(
        async (q?: string | null): Promise<void> => {
            if (companyId) {
                setLoading();

                try {
                    const data = await Axios.post("/admincompanies/SQL", {
                        query: q,
                        companyId: companyId,
                    });

                    let d = data.data;
                    if (data.data.length === 0) {
                        setSqlQueryResponse([]);
                        setSqlQueryWarning("Query returned no rows");
                        d = undefined;
                    }
                    setSqlQueryResponse(d);
                } catch (e: any) {
                    setSqlQueryError(e?.response?.data?.Message);
                } finally {
                    setNotLoading();
                }
            }
        },
        [companyId, setLoading, setNotLoading],
    );

    const executeSqlQuery = useCallback(
        (e: any = undefined, query: string | undefined = undefined) => {
            if (e && e.preventDefault) e.preventDefault();
            setSqlQueryResponse(undefined);
            setSqlQueryWarning(undefined);
            setSqlQueryError(undefined);
            setSqlQueryColumns(undefined);

            const q = query || sqlQuery;

            executeSqlQueryContinue(q);
        },
        [sqlQuery, executeSqlQueryContinue],
    );

    const mustCheck = useMemo(() => {
        const q = sqlQuery;

        const queryLower = q?.toLowerCase();

        let mustCheck = false;

        if (queryLower) {
            if (
                queryLower.indexOf("delete") != -1 &&
                queryLower.indexOf("where") == -1
            ) {
                mustCheck = true;
            }
        }

        return mustCheck;
    }, [sqlQuery]);

    const getSQLDefinitions = useCallback(async (): Promise<SQLDefinition[]> => {
        if (companyId) {
            try {
                const {data} = await axios.post(
                    "/AdminCompanies/SQLTables",
                    {},
                    {params: {companyId}},
                );

                const firstData = data[0];
                if (firstData) {
                    return firstData;
                }
            } catch (e) {
                console.error(e);
            }
        }

        return [];
    }, [companyId]);

    return (
        <SQLEditorGlobal
            setSqlQuery={setSqlQuery}
            mustCheck={mustCheck}
            loading={loading}
            sqlQueryResponse={sqlQueryResponse}
            executeSqlQuery={executeSqlQuery}
            sqlQueryError={sqlQueryError}
            defaultHeight={defaultHeight}
            sqlQueryWarning={sqlQueryWarning}
            sqlQuery={sqlQuery}
            sqlQueryChanged={sqlQueryChanged}
            identifier={companyId?.toString() ?? ""}
            getSQLDefinitions={getSQLDefinitions}
            metadataCompanyId={companyId}
        />
    );
};
